import { PageOptionsDto } from "../../../Shared/dto/page.options.dto";
import { HttpService } from "../../../Shared/Utils/HttpService";
import { CreateApprovalInput } from "../models/CreateApprovalInput";

export class ApprovalService {
  static async create(createApprovalInput: CreateApprovalInput) {
    return await HttpService.request({
      url: "/approvals/create",
      method: "POST",
      data: createApprovalInput,
    });
  }

  static async approve(createApprovalInput: CreateApprovalInput) {
    return await HttpService.request({
      url: "/approvals/approve",
      method: "POST",
      data: createApprovalInput,
    });
  }
  static async cancel(createApprovalInput: CreateApprovalInput) {
    return await HttpService.request({
      url: "/approvals/cancel",
      method: "POST",
      data: createApprovalInput,
    });
  }

  static async getById(id: string) {
    return await HttpService.request({
      url: `/approvals/find/${id}`,
      method: "GET",
    });
  }

  static async update(id: string, updateApprovalInput: CreateApprovalInput) {
    return await HttpService.request({
      url: `/approvals/${id}`,
      method: "PUT",
      data: updateApprovalInput,
    });
  }

  static async deleteOne(id: string) {
    return await HttpService.request({
      url: `/approvals/${id}`,
      method: "DELETE",
    });
  }


  static async delete(ids: string[]) {
    return await HttpService.request({
      url: `/approvals/${JSON.stringify(ids)}`,
      method: "DELETE",
    });
  }


  static async getAll(pageOptions: PageOptionsDto) {
    const queryParams = new URLSearchParams({
      order: pageOptions.order || "DESC",
      page: pageOptions.page.toString(),
      query: pageOptions.query || "",
      take: pageOptions.take.toString(),
    }).toString();

    return await HttpService.request({
      url: `/approvals/find?${queryParams}`,
      method: "GET",
    });
  }

  static async findAll(findOptions: Object) {
    const query = encodeURIComponent(JSON.stringify(findOptions));
    return await HttpService.request({
      url: `/approvals?findOptions=${query}`,
      method: "GET",
    });
  }

  static async search(query: string) {
    return await HttpService.request({
      url: `/approvals/search?query=${encodeURIComponent(query)}`,
      method: "GET",
    });
  }
}
